<template>
  <Component
    :is="tag"
    class="rs-badge"
    :class="badgeClasses"
  >
    <slot />
  </Component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsBadge',
  props: {
    /**
        * Adds a `border-radius` to give it a pill shape.
        */
    pill: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: 'span',
    },
    /**
     * Color variants: primary | secondary | success | warning | error | info | dark | light
     */
    variant: {
      type: String,
      default: 'primary',
      validator: (prop?: string) => [
        'primary',
        'secondary',
        'success',
        'warning',
        'error',
        'info',
        'dark',
        'light',
      ].includes(prop ?? 'primary'),
    },
  },
  computed: {
    badgeClasses(): Record<string, boolean> {
      return {
        'rs-badge--pill': this.pill,
        'rs-badge--primary': this.variant === 'primary',
        'rs-badge--secondary': this.variant === 'secondary',
        'rs-badge--success': this.variant === 'success',
        'rs-badge--warning': this.variant === 'warning',
        'rs-badge--error': this.variant === 'error',
        'rs-badge--info': this.variant === 'info',
        'rs-badge--light': this.variant === 'light',
        'rs-badge--dark': this.variant === 'dark',
      };
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.rs-badge{
  padding: .25em .4em;
  display: inline-block;
  line-height: 1rem;
  font-size: 75%;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  border-radius: 0.25rem;
  background-color: $primary-color;
  color: $white;
  transition: color .15s ease-in-out,
    background-color .15s ease-in-out, border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  @each $name, $color in $colors {
    &--#{$name} {
      background-color: $color;
    }
  }
  &--secondary{
    background-color: $secondary-color;
  }
  &--light{
    background-color: rgba(201,204, 223, 0.44);
    color: $tertiary-muted;
  }
  &--dark{
    color: $white;
  }
  &--pill{
    padding-right: .9em;
    padding-left: .9em;
    border-radius: 10rem;
  }
}
</style>
